import { useState } from 'react'
import toast from 'react-hot-toast'
import Modal from '../../ui/Modal'
import { deliveriesAPI } from '../../../api/deliveries'

const textareaStyle: React.CSSProperties = {
  width: '100%', padding: '12px 14px',
  borderRadius: 12, border: '1.5px solid #E5E7EB',
  fontSize: 14, fontFamily: "'DM Sans', sans-serif",
  resize: 'vertical', outline: 'none',
  background: '#FAFAFA', color: '#0D1117',
  boxSizing: 'border-box',
}

const btnStyle: React.CSSProperties = {
  display: 'flex', alignItems: 'center', gap: 8,
  border: 'none', borderRadius: 12,
  padding: '12px 20px', color: '#fff',
  fontSize: 14, fontWeight: 600,
  cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
  flex: 1, justifyContent: 'center',
}

interface CommentModalProps {
  deliveryId: string
  onClose: () => void
  onSuccess: () => void
}

export const CommentModal = ({ deliveryId, onClose, onSuccess }: CommentModalProps) => {
  const [comment, setComment] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async () => {
    if (!comment.trim()) return
    setIsLoading(true)
    try {
      await deliveriesAPI.addComment(deliveryId, comment.trim())
      toast.success('Commentaire ajouté')
      onSuccess()
      onClose()
    } catch {
      toast.error("Erreur lors de l'ajout")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal open title="Ajouter un commentaire" onClose={onClose} size="sm">
      <p style={{ color: '#6B7280', fontSize: 13, marginBottom: 16, marginTop: 0 }}>
        Le commentaire sera visible dans l'historique du colis.
      </p>
      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="Ex : Le client m'a demandé de laisser le colis devant la porte..."
        rows={5} maxLength={500}
        style={textareaStyle}
        autoFocus
      />
      <div style={{ textAlign: 'right', fontSize: 11, color: '#9CA3AF', marginBottom: 16 }}>
        {comment.length}/500
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        <button onClick={onClose} style={{ ...btnStyle, background: '#F3F4F6', color: '#374151' }}>
          Annuler
        </button>
        <button
          onClick={handleSubmit}
          disabled={!comment.trim() || isLoading}
          style={{ ...btnStyle, background: '#6366F1', opacity: (!comment.trim() || isLoading) ? 0.7 : 1, cursor: (!comment.trim() || isLoading) ? 'not-allowed' : 'pointer' }}
        >
          {isLoading ? 'Envoi...' : 'Ajouter le commentaire'}
        </button>
      </div>
    </Modal>
  )
}
